import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import React from "react";
import { getCloudOrgStructureElement } from "slices/cloudOrgStructure";
import { createLookupRegistry, useLookupOnce } from "common/useLookupOnce";

const registry = createLookupRegistry();

const NiceLocation = (props) => {
  const wantedResource = props.children;

  const location = useSelector((state) =>
    state.cloudOrgStructure?.data?.list?.find((org) => org.id === wantedResource)
  );

  useLookupOnce(
    registry,
    wantedResource,
    (id) => getCloudOrgStructureElement({ id }),
    { resolved: !!location }
  );

  return <>{location ? <Box>{location.name}</Box> : <Box>{wantedResource}</Box>}</>;
};

export default React.memo(NiceLocation);
